// extracted by mini-css-extract-plugin
export default {"basic-panel":"CompaniesTable_basic-panel__zqgCT","disabled":"CompaniesTable_disabled__TiVzI"};